module.exports = __webpack_public_path__ + "img/icon6.bc2033bf.png";